module.exports = "<svg version=\"1.1\" id=\"圖層_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 44.7 44.7\" style=\"enable-background:new 0 0 44.7 44.7;\" xml:space=\"preserve\"><style type=\"text/css\"> .play-st0 {fill:#1BE0A8;} .play-st1 {fill:#FFFFFF;} </style><g id=\"グループ_399\" transform=\"translate(-5893.385 -1720.944)\"><circle id=\"楕円形_29\" class=\"play-st0\" cx=\"5915.7\" cy=\"1743.3\" r=\"22.3\"></circle><path id=\"パス_1711\" class=\"play-st1\" d=\"M5922.6,1743.3l-10.6-6.1v12.3L5922.6,1743.3z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plugin/play.svg
// module id = SvqX
// module chunks = 1